module.exports = __webpack_public_path__ + "static/sadforever-ad3c4ad0fc9af81c65ac6f2014441a86.jpg";